import React from "react"
import { Home } from "../conponents"



export const HomePage = () => <Home />